export default {
  setSelectedItem(state, selectedItem) {
    state.selectedItem = selectedItem;
  },
};
